export default "__VITE_ASSET__CQBFzTnL__"